/*
This file is located in the main branch
Last time the file was updated (UTC): [02.07.2024 18:52:59]
Permissions to update outside the main branch: [false]
*/

import { DropDown, DropDownList, useGridFilterUrlContext } from '@finbeat/react-toolkit';
import { getDictList } from 'axios/dictionaryApi';
import useApi from 'hooks/useApi';
import { t } from 'i18next';
import { DictionaryFilter as DictionaryFilterType } from 'models/api/dictionary';
import DictItem from 'models/api/dictItem';
import { useMemo, useState } from 'react';
import { useQuery } from 'react-query';
import { FormGroup } from 'reactstrap';

export default function DictionaryFilter() {
    const { draftFilter, setDraftFilter } = useGridFilterUrlContext<DictionaryFilterType>();
    const api = useApi();

    const [dictList, setDictList] = useState<DictItem[]>([]);

    const nameList = useMemo(
        () =>
            dictList.length
                ? dictList.map((x) => ({ id: x.code, name: `[${x.code}]: ${x.name}` }))
                : [],
        [dictList]
    );

    const getDictListQuery = useQuery('dictList', () => getDictList(api), {
        onSuccess: (data) => {
            setDictList(data);
        },
        enabled: !dictList.length,
    });

    const changeProp = (value: DropDown) =>
        setDraftFilter((prevState) => ({
            ...prevState,
            dictName: value.name || '',
            dictCode: (value.id || '').toString(),
        }));

    return (
        <FormGroup>
            <DropDownList
                name="dictFilter"
                value={`${t('BackOfficeDict')}: ${draftFilter.dictName} (${t('BackOfficeCode')}: ${
                    draftFilter.dictCode
                })`}
                setValue={(value) => changeProp(value)}
                label={t('BackOfficeDict')}
                items={nameList}
                isLoading={getDictListQuery.isFetching}
                onlyListValue
                isClearable={false}
            />
        </FormGroup>
    );
}
